<template>
  <div class="work-zone-container">
    <battery-info-modal v-if="showBatteryPopup" @close="showBatteryPopup = false" />
    <current-task-form v-if="showFormModal" @close="closeTaskForm" @submitted="refreshDataAfterModal" :initialDate="dateForTask" :plannedTask="evaluationRecord" :futureTask="addFutureTask" />
    <pop-up-tracker-feedback v-if="feedbackRequired && feedbackRecord" @close="resetFeedbackRecord" :record="feedbackRecord" />
    <mood-tracker-task-review v-if="showTaskDetails" :taskDetail="taskDetails" @close="closeTaskDetails" @deleted="refreshAfterDelete" />

    <div class="controls-top">
      <div class="control-buttons">
        <button class="btn btn-accent control-button" @click="addEmotionManually(true)">
          + Добавить задачу
        </button>

        <button class="btn btn-accent control-button" @click="addEmotionManually(false)">
          + Отметить эмоцию
        </button>
      </div>
      <div class="battery-block">
        <BatteryIndicator @click="showBatteryPopup = true" :level="batteryPercent" />
      </div>
    </div>

    <task-calendar v-if="trackerSettings?.current_mode === 'work'" :tasks="userRecords"  @month-change="handleMonthChange" @day-click="handleDayClick" @task-click="handleTaskClick"/>
    <tracker-records v-if="trackerSettings?.current_mode === 'test' && !contentLoading"
                     :startDate="testModeStartDate"
                     @update:startDate="testModeStartDate = $event"
    />
    <div v-if="!trackerSettings?.current_mode || contentLoading" class="loader-wrapper">
      <mini-preloader />
    </div>

    <div class="controls-bottom">
      <div class="control-buttons">
        <button class="btn btn-accent control-button" @click="$emit('showAnalytics')">
          Аналитика
        </button>
      </div>
      <div class="helper-block">

      </div>
    </div>
  </div>
</template>

<script>

import BatteryIndicator from "@/views/MoodTracker/BatteryIndicator.vue";
import {onBeforeMount, onBeforeUnmount, ref, watch} from "@vue/runtime-core";
import {computed} from "@vue/reactivity";
import {useStore} from "vuex";
import BatteryInfoModal from "@/views/MoodTracker/BatteryInfoModal.vue";
import MoodTrackerForm from "@/views/MoodTracker/MoodTrackerForm.vue";
import CurrentTaskForm from "@/views/MoodTracker/MoodTrackerCurrentTaskForm.vue";
import TaskCalendar from "@/views/MoodTracker/MoodTrackerCalendarBlock.vue";
import PopUpTrackerFeedback from "@/views/MoodTracker/MoodTrackerFeedbackPopup.vue";
import {notify} from "@kyvg/vue3-notification";
import {onMounted} from "vue";
import MoodTrackerTaskReview from "@/views/MoodTracker/MoodTrackerTaskReview.vue";
import TrackerRecords from "@/views/MoodTracker/MoodTrackerHistoryList.vue";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";

export default {
  components: {
    MiniPreloader,
    TrackerRecords,
    MoodTrackerTaskReview,
    PopUpTrackerFeedback, TaskCalendar, CurrentTaskForm, MoodTrackerForm, BatteryInfoModal, BatteryIndicator},
  setup() {
    const store = useStore();
    const showBatteryPopup = ref(false);
    const showFormModal = ref(false);
    const addFutureTask = ref(false);
    const contentLoading = ref(false);

    const batteryPercent = computed(() => store.state.tracker.batteryLevel);
    const userRecords = computed(() => store.state.tracker.userTasks);
    const trackerSettings = computed(() => store.state.tracker.settingsData);

    const lastDateForm = {
      start_date: null,
      end_date: null,
    }

    const dateForTask = ref(null);

    const feedbackRequired = ref(false);
    const feedbackRecord = ref(null);
    const feedbackPending = computed(() => store.state.tracker.pendingFeedback);

    const evaluationPending = computed(() => store.state.tracker.pendingEvaluation);
    const evaluationRequired = ref(false);
    const evaluationRecord = ref(null);

    const taskDetails = ref();
    const showTaskDetails = ref(false);

    const getStartAndEndDate = (periods) => {
      let startPeriod = new Date();
      let startPeriodHours = periods[0].split(':')[0];
      let startPeriodMinutes = periods[0].split(':')[1];
      startPeriod.setHours(startPeriodHours, startPeriodMinutes, 0);

      let endPeriod = new Date();
      let endPeriodHours = periods[1].split(':')[0];
      let endPeriodMinutes = periods[1].split(':')[1];
      endPeriod.setHours(endPeriodHours, endPeriodMinutes, 59);

      return [startPeriod, endPeriod];
    }

    const compareTimeIsGreaterThanNow = (periods) => {
      const now = new Date();
      const [startDate, endDate] = getStartAndEndDate(periods);
      return now >= endDate;
    }

    const compareTimeIsBeforeOrBetween = (periods) => {
      const now = new Date();
      const [startDate, endDate] = getStartAndEndDate(periods);
      const startWithOffset = new Date(startDate.getTime() - 15 * 60 * 1000);
      return now >= startWithOffset && now <= endDate;
    };

    const compareDateIsPriorToToday = (date) => {
      const targetDate = new Date(date);
      const today = new Date();

      targetDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return targetDate < today;
    };

    const addEmotionManually = (futureTask = false) => {
      addFutureTask.value = futureTask;
      dateForTask.value = null;
      showFormModal.value = true;
    }

    const checkRecordsFeedback = () => {
      feedbackPending.value?.map((record) => {
        if (record.interval && !feedbackRequired.value) {
          if (compareTimeIsGreaterThanNow(record.interval.split('-')) || compareDateIsPriorToToday(record.date)) {
            addFutureTask.value = false;
            feedbackRecord.value = record;
            feedbackRequired.value = true;
          }
        }
      })
    }

    const checkRecordsEvaluation = () => {
      evaluationPending.value?.map((record) => {
        if (record.interval && !evaluationRequired.value) {
          if (compareTimeIsBeforeOrBetween(record.interval.split('-'))) {
            addFutureTask.value = false;
            evaluationRecord.value = record;
            evaluationRequired.value = true;
            showFormModal.value = true;
          }
        }
      })
    }

    const resetFeedbackRecord = () => {
      feedbackRecord.value = null;
      feedbackRequired.value = false;
      store.dispatch('tracker/getFeedbackPendingTasks');
      getUserTasks(lastDateForm.start_date, lastDateForm.end_date, true);
    }

    const closeTaskForm = () => {
      evaluationRecord.value = null;
      evaluationRequired.value = null;
      showFormModal.value = false;
      addFutureTask.value = false;
    }

    const refreshAfterDelete = () => {
      evaluationRecord.value = null;
      evaluationRequired.value = null;
      showFormModal.value = false;
      addFutureTask.value = false

      store.dispatch('tracker/getPendingEvaluationTasks');
      getUserTasks(lastDateForm.start_date, lastDateForm.end_date, true);
    }

    const refreshDataAfterModal = () => {
      store.dispatch('tracker/getCurrentBatteryLevel');
      getUserTasks(lastDateForm.start_date, lastDateForm.end_date, true);
    }

    const getUserTasks = (startDate, endDate, loader) => {
      if (loader) {
        contentLoading.value = true;
      }

      store.dispatch('tracker/getAllUserTasks', {start_date: startDate, end_date: endDate}).then(() => {
        if (loader) {
          contentLoading.value = false;
        }
      });
    }

    const handleMonthChange = (payload) => {
      lastDateForm.start_date = payload.start;
      lastDateForm.end_date = payload.end;

      if (trackerSettings.value?.current_mode) {
        getUserTasks(lastDateForm.start_date, lastDateForm.end_date, true);
      }
    }

    const handleDayClick = ({ date }) => {
      const clickedDate = new Date(date)
      const today = new Date()

      clickedDate.setHours(0, 0, 0, 0)
      today.setHours(0, 0, 0, 0)

      if (clickedDate < today) {
        notify({
          title: "Нельзя внести запись за прошедший день",
          type: "info"
        })
        return;
      }

      dateForTask.value = date;
      showFormModal.value = true;
    }

    const handleTaskClick = ({ task }) => {
      taskDetails.value = task;
      showTaskDetails.value = true;
    }

    const closeTaskDetails = () => {
      taskDetails.value = null;
      showTaskDetails.value = false;
    }

    const getTodayDate = () => {
      const today = new Date()
      const currentDate = today.getDate()
      const currentMonth = today.getMonth() + 1
      return today.getFullYear() + '-' + (currentMonth < 10 ? '0' + currentMonth : currentMonth) + '-' + (currentDate < 10 ? '0' + currentDate : currentDate);
    }

    const testModeStartDate = ref(getTodayDate());

    let feedbackInterval = null;
    let evaluationInterval = null;

    watch(() => trackerSettings.value?.current_mode, () => {
      if (trackerSettings.value?.current_mode) {
        store.commit('tracker/clearRecords');

        store.dispatch('tracker/getPendingEvaluationTasks');
        store.dispatch('tracker/getFeedbackPendingTasks');
        feedbackRecord.value = null;
        feedbackRequired.value = false;

        evaluationRecord.value = null;
        evaluationRequired.value = false;

        if (trackerSettings.value?.current_mode === 'test') {
          lastDateForm.start_date = testModeStartDate.value;
          getUserTasks(lastDateForm.start_date, lastDateForm.end_date, true);
        }

        if (!feedbackInterval) {
          feedbackInterval = setInterval(() => {
            store.dispatch('tracker/getFeedbackPendingTasks')
          },  10 * 60 * 1000)
        }

        if (!evaluationInterval) {
          evaluationInterval = setInterval(() => {
            store.dispatch('tracker/getPendingEvaluationTasks')
          },  10 * 60 * 1000)
        }
      }
    }, {deep: true});

    watch(() => testModeStartDate.value, (value) => {
      if (trackerSettings.value?.current_mode === 'test') {
        lastDateForm.start_date = value;
      }
    }, { immediate: true })

    watch(() => feedbackPending.value, () => {
      checkRecordsFeedback();
    }, {immediate: true});

    watch(() => evaluationPending.value, () => {
      checkRecordsEvaluation();
    }, {immediate: true});

    onBeforeMount(() => {
      store.dispatch('tracker/getColors');
      store.dispatch('tracker/getTasks');
    });

    onBeforeUnmount(() => {
      if (feedbackInterval) {
        clearInterval(feedbackInterval)
        feedbackInterval = null
      }

      if (evaluationInterval) {
        clearInterval(evaluationInterval)
        evaluationInterval = null
      }
    });

    return {
      showBatteryPopup,
      batteryPercent,
      showFormModal,
      refreshDataAfterModal,
      userRecords,
      handleMonthChange,
      handleDayClick,
      feedbackRecord,
      feedbackRequired,
      resetFeedbackRecord,
      addEmotionManually,
      dateForTask,
      handleTaskClick,
      evaluationRequired,
      evaluationRecord,
      closeTaskForm,
      trackerSettings,
      showTaskDetails,
      taskDetails,
      closeTaskDetails,
      refreshAfterDelete,
      addFutureTask,
      testModeStartDate,
      contentLoading
    }
  }
}
</script>


<style scoped lang="scss">
  .controls-top {
    display: flex;
    justify-content: space-between;

    .control-buttons {
      display: flex;
      column-gap: 16px;

      @media (max-width: 930px) {
        flex-direction: column;
        row-gap: 16px;
      }
    }
  }

  .work-zone-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 0;

    .control-button {
      border-radius: 16px;
      font-weight: 600;
    }
  }

  .battery-block {
    cursor: pointer;
  }

  .battery-block:hover {
    opacity: 0.9;
  }

  .loader-wrapper {
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>